import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/Button';

export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 400px
      setIsVisible(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 border-t border-hairline bg-roughneck-900/95 backdrop-blur-lg sm:hidden">
      <div className="flex items-center justify-between gap-4 px-4 py-3">
        <div className="flex-1">
          <p className="text-sm font-medium text-white">Ready to modernize your field ops?</p>
        </div>
        <Button as="anchor" href="https://app.roughneck.io/register" size="sm">
          Get Started
        </Button>
      </div>
    </div>
  );
}
